import { FilterValue } from "../Filters/FilterValue";

export const ShippingType: FilterValue[] = [
  { id: "0", value: "" },
  { id: "8", value: "Remote" },
  { id: "9", value: "Bulk" },
  { id: "10", value: "Bulk-International" },
  { id: "11", value: "Bulk-Local" },
  { id: "12", value: "Hybrid" },
  { id: "13", value: "International" },
];
